import React, { useMemo } from 'react';
import { addDays, format } from 'date-fns';
import { DateField } from '../../../../../../../ui-toolkit';
import { useField } from 'formik';
import { isIssuanceDateCategory } from '../isIssuanceDateCategory';
import { eManualCheckDisbursementCategory } from '../../../../../../../types/accounting/eManualCheckDisbursementCategory';

export const IssuanceDate: React.FC<{
  isReadOnly: boolean;
  isCheckPrinted: boolean;
  hasIssuanceDateEditPermissions: boolean;
}> = ({ isReadOnly, isCheckPrinted, hasIssuanceDateEditPermissions }) => {
  const [{ value: category }] = useField<eManualCheckDisbursementCategory | undefined>('value.category');
  const shouldShowIssuanceDate = useMemo(() => isIssuanceDateCategory(category), [category]);

  const today = useMemo(() => format(new Date(), 'yyyy-MM-dd'), []);
  const maxIssuanceDate = useMemo(() => format(addDays(new Date(), 7), 'yyyy-MM-dd'), []);

  if (!shouldShowIssuanceDate) {
    return null;
  }
  return (
    <DateField
      className={'grow basis-1/3'}
      name={`value.issuanceDate`}
      label={'Issuance Date'}
      isRequired
      readOnly={isReadOnly || isCheckPrinted || !hasIssuanceDateEditPermissions}
      minDate={today}
      maxDate={maxIssuanceDate}
    />
  );
};
